import { useEffect, useState } from 'react';

import {
  LONG_WAIT_HINT_DELAY_MS,
  LONG_WAIT_HINT_ROTATE_MS,
} from '@pages/Integrations/IntegrationsList/components/ConnectIntegrationModal/constants';

interface UseLongWaitHintParams {
  /** Ожидание идёт прямо сейчас (шаг в состоянии загрузки) */
  isWaiting: boolean;
  /** Заготовленные подсказки под конкретный шаг */
  hints: string[];
}

interface LongWaitHint {
  /** Ожидание затянулось — пора объяснить человеку, что происходит */
  isLong: boolean;
  /** Текущая подсказка из набора */
  hint: string | null;
}

/**
 * Долгое ожидание шага подключения (task/10903): первые
 * LONG_WAIT_HINT_DELAY_MS ничего не меняется — короткие ответы не должны
 * мигать лишним текстом. Дальше показываем подсказки по кругу, меняя их
 * каждые LONG_WAIT_HINT_ROTATE_MS.
 */
export const useLongWaitHint = ({
  isWaiting,
  hints,
}: UseLongWaitHintParams): LongWaitHint => {
  const [isLong, setIsLong] = useState(false);
  const [hintIndex, setHintIndex] = useState(0);

  useEffect(() => {
    if (!isWaiting) {
      setIsLong(false);
      setHintIndex(0);
      return;
    }

    const delayTimer = window.setTimeout(
      () => setIsLong(true),
      LONG_WAIT_HINT_DELAY_MS
    );

    return () => window.clearTimeout(delayTimer);
  }, [isWaiting]);

  useEffect(() => {
    if (!isLong || hints.length <= 1) {
      return;
    }

    const rotateTimer = window.setInterval(
      () => setHintIndex((index) => (index + 1) % hints.length),
      LONG_WAIT_HINT_ROTATE_MS
    );

    return () => window.clearInterval(rotateTimer);
  }, [isLong, hints.length]);

  return {
    isLong,
    hint: isLong ? hints[hintIndex] ?? null : null,
  };
};
